import { PhilatelicItem } from "@briefmarken_katalog/types";
import type { Locale } from '$lib/i18n';

const jsonReviver = (key: string, value: any) => {
  if (key == "date_of_issue" || key == "expiry_date") return new Date(value);
  return value;
}

export function parseJSONtoPhilatelicItems(json: string): PhilatelicItem[]
{
  return JSON.parse(json, jsonReviver) as PhilatelicItem[];
}

export function parseJSONtoPhilatelicItem(json: string): PhilatelicItem
{
  return JSON.parse(json, jsonReviver) as PhilatelicItem;
}

/** Returns yyyy-mm-dd — required for HTML <input type="date"> value bindings. */
export function formatDate(date: Date): string {
  if (!date) return '';
  return date.toISOString().split('T')[0];
}

const MONTHS: Record<Locale, string[]> = {
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  de: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
};

/**
 * Returns a locale-aware display string with abbreviated month name.
 * English: "Apr 05 2026", German: "05. Apr 2026"
 */
export function formatDateDisplay(date: Date, currentLocale: Locale): string {
  if (!date) return '';
  const y = date.getUTCFullYear();
  const mon = MONTHS[currentLocale][date.getUTCMonth()];
  const d = date.getUTCDate().toString().padStart(2, '0');
  return currentLocale === 'en' ? `${mon} ${d} ${y}` : `${d}. ${mon} ${y}`;
}